import { QueryClient, keepPreviousData } from '@tanstack/react-query';
import { ApiError } from '@/lib/api/errors';

/** staleTime / gcTime defaults — API_MAPPING.md Part VII + FRONTEND_ARCHITECTURE §8.7 */
export const STALE_TIMES = {
  dashboardStats: 30_000,
  conversationList: 15_000,
  crmLists: 30_000,
  tenantConfig: 5 * 60_000,
  voiceStatus: 60_000,
  industryConfigs: 10 * 60_000,
  staticNav: Number.POSITIVE_INFINITY,
} as const;

export const GC_TIMES = {
  fiveMin: 5 * 60_000,
  tenMin: 10 * 60_000,
  thirtyMin: 30 * 60_000,
  oneHour: 60 * 60_000,
} as const;

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: STALE_TIMES.dashboardStats,
        gcTime: GC_TIMES.fiveMin,
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          if (error instanceof ApiError && (error.status === 401 || error.status === 403)) {
            return false;
          }
          return failureCount < 1;
        },
      },
      mutations: {
        retry: false,
      },
    },
  });
}

export const queryPolicies = {
  dashboardStats: { staleTime: STALE_TIMES.dashboardStats, gcTime: GC_TIMES.fiveMin },
  conversationList: { staleTime: STALE_TIMES.conversationList, gcTime: GC_TIMES.tenMin, placeholderData: keepPreviousData },
  crmLists: { staleTime: STALE_TIMES.crmLists, gcTime: GC_TIMES.tenMin, placeholderData: keepPreviousData },
  tenantConfig: { staleTime: STALE_TIMES.tenantConfig, gcTime: GC_TIMES.thirtyMin },
  voiceStatus: { staleTime: STALE_TIMES.voiceStatus, gcTime: GC_TIMES.fiveMin },
  industryConfigs: { staleTime: STALE_TIMES.industryConfigs, gcTime: GC_TIMES.oneHour },
  staticNav: { staleTime: STALE_TIMES.staticNav, gcTime: GC_TIMES.oneHour },
} as const;
